export default __webpack_public_path__ + "fonts/plan-skip-tracing.svg";